<script setup lang="ts">
defineProps<{
  title?: string
  count?: string | number
}>()
</script>

<template>
  <section class="border-border flex flex-col gap-4 border-t px-6 py-7 first:border-t-0 first:pt-0">
    <div v-if="title || $slots.action" class="flex flex-wrap items-center justify-between gap-3">
      <h3 v-if="title" class="text-foreground flex items-center gap-2 text-sm leading-snug font-semibold">
        {{ title }}
        <Badge v-if="count !== undefined" variant="outline" class="bg-background tabular-nums">{{ count }}</Badge>
      </h3>
      <slot name="action" />
    </div>
    <slot />
  </section>
</template>
